module.exports = __webpack_public_path__ + "media/AUDIO 10.19308cfd.mp3";